import { BaseellaStatus } from '@ui/src';

export interface DashboardValue {
  name: string;
  value?: string;
  id?: string;
  warning?: boolean;
  percent?: string;
  count?: string;
  data?: {
    name: string;
    value: string;
    percent?: string;
    date?: string;
  }[];
}

export enum ViewMode {
  CHARTS = 'CHARTS',
  GRID = 'GRID',
}

export enum Period {
  TODAY = 'TODAY',
  YESTERDAY = 'YESTERDAY',
  WEEK = 'WEEK',
  MONTH = 'MONTH',
  QUARTER = 'QUARTER',
}

export enum TransactionsType {
  INCOMING = 'INCOMING',
  OUTGOING = 'OUTGOING',
}

export interface DashboardItemProps {
  isLoading?: boolean;
  values?: any;
  count?: number;
  // viewMode: ViewMode;
  selectedChart?: {
    value: DashboardValue;
    transactionsType?: TransactionsType;
    period?: Period;
    dates?: string[];
  };
  setSelectedChart: (data: {
    value: DashboardValue;
    transactionsType?: TransactionsType;
    period?: Period;
    dates?: string[];
  }) => void;
  // setRightSideVisible: (data: boolean) => void;
  requestInProgress?: boolean;
}

export interface Response<T> {
  data: {
    stats: T[];
    total: number;
  };
}

export interface CustomerStat {
  status: string;
  count: number;
  percent: number;
}

export interface TransactionStat {
  baseellaStatus: BaseellaStatus;
  count: number;
  percent: number;
}

export interface PaymentTypeStat {
  paymentType: string;
  count: number;
  percent: number;
  amountBC: number;
}

export interface FinancialStat {
  averageEmoney: number;
  capitalAdequacy: number;
  currentSafeguardedFunds: number;
  netShareholderAssets: number;
  profitLoss: number;
  totalIncomingFunds: number;
  totalOutgoingFunds: number;
}
